// extracted by mini-css-extract-plugin
export var centerList = "_ic-6";
export var centerLoc = "_ic-a";
export var centerName = "_ic-9";
export var centerOptionBody = "_ic-8";
export var centerRow = "_ic-7";
export var centerStatus = "_ic-b";
export var empty = "_ic-5";
export var externalIcon = "_ic-c";
export var fieldHeader = "_ic-2";
export var fieldHelp = "_ic-4";
export var fieldLabel = "_ic-3";
export var panel = "_ic-0";
export var removeBtn = "_ic-d";
export var section = "_ic-1";